import { useTranslation } from 'hooks';
import Form from 'components/ui/form';
import RoundButton from 'components/ui/roundButton';
import './formLayout.scss';

interface Props {
  title: string;
  text?: string;
  subtext?: string;
  body: React.ReactNode;
  submitButton: React.ReactNode;
  onSubmit: () => void;
  onReturn?: () => void;
}

export const FormLayout: React.FC<Props> = ({
  title,
  text,
  subtext,
  body,
  submitButton,
  onSubmit,
  onReturn,
}) => {
  const getTranslate = useTranslation();

  return (
    <Form customClass='form-layout' onSubmit={onSubmit}>
      <div className='form-layout__main'>
        <div className='form-layout__header'>
          <div className='form-layout__header-wrapper'>
            <div className='form-layout__header-inner'>
              {onReturn ? (
                <RoundButton
                  icon='im-Arrow-left-Option-2'
                  type='button'
                  status='primary'
                  iconSize={10}
                  size={20}
                  onClick={onReturn}
                />
              ) : null}
              <h1 className='form-layout__title'>{getTranslate(title)}</h1>
            </div>
          </div>

          {text ? (
            <div className='form-layout__text'>{getTranslate(text)}</div>
          ) : null}
          {subtext ? (
            <div className='form-layout__text'>{getTranslate(subtext)}</div>
          ) : null}
        </div>

        <div className='form-layout__body'>{body}</div>
      </div>

      <div className='form-layout__footer'>
        <div className='form-layout__footer-decorator' />
        <div className='form-layout__footer-content'>
          <div className='form-layout__footer-corner'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='31'
              height='31'
              viewBox='0 0 31 31'
              fill='none'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M31 2L31 0H0V30.9997H2.00003C2.00003 12.9998 14 2 31 2Z'
                fill='white'
              />
            </svg>
          </div>

          {submitButton}
        </div>
      </div>
    </Form>
  );
};
